import React from 'react';
import { ThemeContext } from '../context/themeContext';

const Toggle = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);

  function isDark() {
    return theme === 'dark';
  }

  return (
    <button
      aria-label="test"
      type="button"
      className="mode"
      onClick={() => setTheme(isDark() ? 'light' : 'dark')}
    />
  );
};

export default Toggle;
